<template>
  <div :class="{
    isMobile: isMobile()
  }">
    <div class="title">{{ detailInfo.title }}</div>

    <div class="link-box flex items-center">
      <div v-if="detailInfo.from" class="common from flex items-center">
        <div class="icon"></div>

        <div class="text" @click="open">{{ detailInfo.from }}</div>
      </div>

      <div class="common time flex items-center">
        <div class="icon"></div>

        <div class="text">{{ detailInfo.create_time }}</div>
      </div>
    </div>
  </div>

</template>


<script>
/* eslint-disable */
import { isMobile } from '@/utils/index'
export default {
  data() {
    return {

    }
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    isMobile,
    open() {
      window.open(this.detailInfo.from_url, '_blank');
    }
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>

.isMobile {
  .title {
    margin-bottom: 10px;
    font-size: 18px;
  }
}

.title {
  font-size: 24px;
  font-weight: normal;
  color: #0A1121;
  line-height: 36px;
  margin-bottom: 33px;
}

.link-box {
  margin-bottom: 14px;
  .common {
    margin-right: 20px;

    .icon {
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }

    .text {
      font-size: 14px;
      font-weight: 400;
      color: #878A95;
    }

    &.from {
      cursor: pointer;
      .icon {
        background: url(~@/assets/from.png) no-repeat;
        background-size: 100% 100%;
      }
    }

    &.time {
      .icon {
        background: url(~@/assets/detail-time-icon.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    
  }
}
</style>